import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

/**
 * Global user notifications.
 */
@Injectable({
	providedIn: 'root'
})
export class NotificationManager {
	private snackBarNotificationRef: MatSnackBarRef<SimpleSnackBar>;
	private NofticiationQueue: Array<DisplaySnackBarMessageParams> = Array<DisplaySnackBarMessageParams>();
	private isNotificationActive: boolean;

	constructor(private matSnackBar: MatSnackBar) {}

	public displaySnackBarMessage(params: DisplaySnackBarMessageParams): void {
		if (!params?.message) return;

		this.NofticiationQueue.push(params);

		if (!this.isNotificationActive) {
			this.triggerSnackBarMessage();
		}
	}

	private triggerSnackBarMessage(): void {
		if (this.NofticiationQueue.length === 0) {
			return;
		}

		this.isNotificationActive = true;

		const params = this.NofticiationQueue.shift();

		this.snackBarNotificationRef = this.matSnackBar.open(params.message, 'X', {
			duration: params?.ttl ?? 3000,
			panelClass: params?.type === 'error' ? ['error-snack-bar'] : null
		});

		this.snackBarNotificationRef.afterDismissed().subscribe(() => {
			this.isNotificationActive = false;
			this.triggerSnackBarMessage();
		});
	}
}

interface DisplaySnackBarMessageParams {
	message: string;
	ttl?: number;
	type?: 'info' | 'error' | 'warn';
}
